import type { RegisterTranslations } from "../interfaces/register";

export const registerTranslations: RegisterTranslations = {
  register_button: "Sign up",
  create_account_label_prefix: "Don't have an account?",
  create_account_label_button: "Sign up",
  or_label: "Or",
  input_name_label: "Name",
  input_name_placeholder: "Enter your name",
  input_last_name_label: "Last name",
  input_last_name_placeholder: "Enter your last name",
  terms_and_conditions_text: "By signing up, you agree to our terms and conditions.",

  page_title: "Create your account",
  page_subtitle_persona: "We only need your personal details to create your account.",
  page_subtitle_empresa: "Register your personal info and your organization in a single step.",

  account_type_label: "How do you want to register?",
  account_type_persona_label: "Individual",
  account_type_persona_description: "Personal account",
  account_type_empresa_label: "Business",
  account_type_empresa_description: "Register your organization",

  section_user: "Your details",
  section_user_heading: "About you",
  section_user_description: "Information that identifies your personal account.",
  section_organization: "Your organization",
  section_organization_heading: "Workspace",
  section_organization_description: "Information that identifies your organization.",

  terms_text_prefix: "By continuing you agree to the ",
  terms_link: "Terms",
  terms_text_middle: " and the ",
  privacy_link: "Privacy Policy",
  terms_text_suffix: ".",

  user_name_label: "Full name",
  user_name_placeholder: "Enter your full name",
  user_email_label: "Email",
  user_email_placeholder: "you@email.com",
  user_password_label: "Password",
  user_password_placeholder: "At least 8 characters",
  user_country_label: "Country",
  user_phone_label: "Phone",
  user_phone_placeholder: "Number with international prefix",

  org_name_label: "Organization name",
  org_name_placeholder: "Enter the organization name",
  org_email_label: "Contact email",
  org_phone_label: "Contact phone",
  org_country_label: "Country",

  hint_mirror_email: "Same as your personal email",
  hint_mirror_phone: "Same as your personal phone",
  hint_mirror_country: "Same as your personal country",
  hint_mirror_org_name: "Suggested from your name",

  pwd_strength_empty: "Enter a password",
  pwd_strength_weak: "Weak",
  pwd_strength_fair: "Fair",
  pwd_strength_good: "Good",
  pwd_strength_strong: "Strong",
  pwd_strength_aria_label: "Password strength indicator",

  submit_button: "Create account",
  submit_loading: "Creating account...",

  error_required: "This field is required",
  error_email: "Invalid email",
  error_name_length: "Must be between 2 and 100 characters",
  error_org_name_length: "Must be between 2 and 100 characters",
  error_password_min: "Minimum 8 characters",
  error_password_number: "Must include at least one number",
  error_password_symbol: "Must include at least one symbol",
  error_phone_format: "Invalid phone format (E.164)",
  error_country: "Select a country",
  error_email_conflict: "Email already registered",
  error_generic: "Something went wrong. Please try again.",

  verify_title: "Verify your email",
  verify_subtitle: "We sent a 6-digit code to confirm your account.",
  verify_sent_to_label: "We sent the code to",
  verify_new_code_sent_to_label: "We sent a new code to",
  verify_code_label: "Verification code",
  verify_submit_button: "Verify email",
  verify_submitting: "Verifying...",
  verify_resend_button: "Resend code",
  verify_resend_cooldown: "Resend code ({{seconds}}s)",
  verify_resend_sent: "We sent you a new code",
  verify_edit_email_link: "Change",
  verify_edit_email_aria: "Change the email we sent the code to",
  verify_change_email_label: "Correct email",
  verify_change_email_hint: "We'll send a new code there. Your signup details stay as they are.",
  verify_change_email_submit: "Send code",
  verify_change_email_submitting: "Sending...",
  verify_change_email_cancel: "Cancel",
  verify_change_email_success: "Done. We sent a new code to {{email}}",
  verify_change_email_error_same: "That's the email we already sent the code to.",
  verify_change_email_error_in_use: "An account already uses this email. Sign in with it or use another one.",
  verify_change_email_error_org_in_use: "An organization already uses this email. Use another one.",
  verify_change_email_error_generic: "We couldn't change the email. Try again.",
  verify_sign_out_prompt: "Want to use a different account?",
  verify_sign_out: "Sign out",
  verify_success_toast: "Email verified. Welcome!",
  verify_error_invalid_code: "Invalid code. Double-check and try again.",
  verify_error_invalid_code_format: "The code must be 6 digits",
  verify_error_expired: "The code expired. Request a new one.",
  verify_error_already_verified: "This email is already verified.",
  verify_error_rate_limited: "Too many attempts. Wait a moment and try again.",
  verify_error_generic: "We couldn't verify the code. Try again.",
};
